import {lazy} from 'react';

export const LazyPageChooser = lazy(() => import('./page-chooser'));